import { SerializableObject } from '../../common-react/core';

// DTO Object for representing generic Addresses
export class PostalCode extends SerializableObject {
  // The city the address is located in
  public city: string;

  // The zipcode the address is located in
  public postalCode: string;
}
